import {BaseContainerModel} from '../../base-container.model';
import {bl_bi_dashboard_blocks_RowClass, bl_bi_dashboard_RowClass} from '../../../dbschema';


export class DashboardContainerModel extends BaseContainerModel {
  bl_bi_dashboard: bl_bi_dashboard_RowClass = new bl_bi_dashboard_RowClass();
  bl_bi_dashboard_blocks: bl_bi_dashboard_blocks_RowClass[] = [];
}
